import { CONSTANTS } from "client/utils/constants"

const DispositionTypeRequiredAttachment = (choise : any) => {
    switch (choise) {
        case CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASE_TRADE_IN:
           return CONSTANTS.DISPOSITION_CHOICES_ATTACHMENT_NOTES.WRITE_OFF_LEASE_TRADE_IN
        case CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_THEFT_LEASE_ASSET_NO_TITLE:
            return CONSTANTS.DISPOSITION_CHOICES_ATTACHMENT_NOTES.WRITE_OFF_THEFT_LEASE_ASSET_NO_TITLE
        case CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_THEFT_OWNED_ASSET_NO_TITLE:
            return CONSTANTS.DISPOSITION_CHOICES_ATTACHMENT_NOTES.WRITE_OFF_THEFT_OWNED_ASSET_NO_TITLE
        case CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_NO_TITLE:
            return CONSTANTS.DISPOSITION_CHOICES_ATTACHMENT_NOTES.WRITE_OFF_OWNED_ASSET_NO_TITLE
        case CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_NO_TITLE:
            return CONSTANTS.DISPOSITION_CHOICES_ATTACHMENT_NOTES.WRITE_OFF_LEASED_ASSET_NO_TITLE
        case CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_THEFT_OWNED_ASSET_TITLED:
            return CONSTANTS.DISPOSITION_CHOICES_ATTACHMENT_NOTES.WRITE_OFF_THEFT_OWNED_ASSET_TITLED
        case CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_THEFT_LEASED_ASSET_TITLED:
            return CONSTANTS.DISPOSITION_CHOICES_ATTACHMENT_NOTES.WRITE_OFF_THEFT_LEASED_ASSET_TITLED
        case CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_TITLED:
            return CONSTANTS.DISPOSITION_CHOICES_ATTACHMENT_NOTES.WRITE_OFF_OWNED_ASSET_TITLED
        case CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_TITLED:
            return CONSTANTS.DISPOSITION_CHOICES_ATTACHMENT_NOTES.WRITE_OFF_LEASED_ASSET_TITLED
        default:
            return ""
    }
}

export {
    DispositionTypeRequiredAttachment
}